import { LitElement, html, css } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';
import { bannerStyles } from '../styles/banner-styles';

class BnFlash extends LitElement {
  constructor() {
    super();
    this.banners = [];
  }

  static get properties() {
    return {
      banners: { type: Array },
    };
  }

  static get styles() {
    return [sharedStyles, bannerStyles, css`
      :host {
        display: block;
      }
    `];
  }

  render() {
    return html`
      <div id="flash-output">
        ${this.banners.map((b) => html`<div class="banner banner--${b.type}">${b.content}</div>`)}
      </div>
    `;
  }

  clear() {
    this.banners = [];
  }

  add(content, type) {
    this.banners = [...this.banners, { content, type }];
  }

  success(content) {
    this.add(content, 'success');
  }

  info(content) {
    this.add(content, 'info');
  }

  warning(content) {
    this.add(content, 'warning');
  }

  critical(content) {
    this.add(content, 'critical');
  }
}

window.customElements.define('bn-flash', BnFlash);
